// A replay's Vimeo link, as Adam pastes it on AdminWebinars: a page link (vimeo.com/123/abc) or a
// player link (player.vimeo.com/video/123?h=abc). The privacy hash is kept (C30), as Property
// Cashflow For Life v3 does (reference/pcfl-v3/source/app.jsx, parseVimeo). Pure, so a test can
// check it without a browser. A link that doesn't name a video, such as staging's placeholder
// https://vimeo.com/[replay], gives null: nothing to play yet.
export function parseVimeo(input) {
  if (!input) return null
  const s = String(input).trim().replace(/&amp;/g, '&')
  let m = s.match(/^https:\/\/player\.vimeo\.com\/video\/(\d+)(?:\?([^#\s"']*))?/i)
  if (m) {
    const h = m[2] ? (m[2].match(/(?:^|&)h=([0-9a-z]+)/i) || [])[1] : null
    return { id: m[1], hash: h || null }
  }
  m = s.match(/^https:\/\/(?:www\.)?vimeo\.com\/(?:video\/)?(\d+)(?:\/([0-9a-z]{6,}))?(?:[/?#].*)?$/i)
  if (m) return { id: m[1], hash: m[2] || null }
  return null
}

// The iframe's address: Vimeo's own player, with no title, byline or portrait over the video, and
// Do Not Track on. autoplay starts it at once, because the frame is only made after Play is pressed.
export function vimeoSrc(v, { autoplay = false } = {}) {
  const q = []
  if (v.hash) q.push(`h=${v.hash}`)
  q.push('title=0', 'byline=0', 'portrait=0', 'dnt=1')
  if (autoplay) q.push('autoplay=1')
  return `https://player.vimeo.com/video/${v.id}?${q.join('&')}`
}

// Where a replay saves its place (docs/data-model.md 10.1: the member sends only the position; the
// database sets watched_at once it passes the Free webinars product's watched share).
// - every 15 seconds while it plays, and straight away the first time it passes 90%, so the
//   database sees a position past the watched share before the replay ends;
// - on pause, where it stopped, or the start again if it's at the very end;
// - at the end, the start again, so the next play starts from the top.
export const SAVE_EVERY_MS = 15000
export const WATCHED_SHARE = 0.9

export function positionOnPause(seconds, percent) {
  return percent >= 0.98 ? 0 : Math.max(0, Math.floor(seconds || 0))
}

// Where to start: a chapter asked for, or where they left off (more than 10 seconds in), or the top
export function startAt({ chapterSeconds = null, savedSeconds = 0 } = {}) {
  if (chapterSeconds != null) return Math.max(0, chapterSeconds)
  return savedSeconds > 10 ? savedSeconds : 0
}
